// extracted by mini-css-extract-plugin
module.exports = {"scrollable":"SwipesWrapper_scrollable__2L9Sc"};